module.exports = __webpack_public_path__ + "img/plus.339f6379.svg";